export default __webpack_public_path__ + "static/media/15.1669d1a4.jpg";